module.exports = __webpack_public_path__ + "static/media/duplicate.4385dcf4.svg";